<template lang="pug">
  v-expansion-panel()
    v-expansion-panel-content(class="slim-header")
      template(v-slot:actions)
        div(v-if="merchantId" class='header-btn-area')
          p(style="text-align: right;")
            | <strong>Merchant ID</strong> {{ merchantId }}
          AppOutlinedButton MANAGE
        div(v-else)
      LenderListTile(
        slot="header"
        :logoSvg="logoSvg"
        :title="typeLabel"
        :subtitle="name"
        :merchantId="merchantId"
        :enrollmentLink="enrollmentLink"
        :active="active"
        :readMoreLink="readMoreLink"
        :color="color"
      )
      v-divider

      template(v-if="!active && merchantId")
        p.pa-4 Your Merchant ID: {{ merchantId }} has been deactivated, please contact us using the Intercom Button or call us at (786) 375-9482

      v-card(v-else-if="description")
        v-card-text
          //TODO add hash method for key
          template(
            v-for="bit in description"
          )
            p(
              v-if="typeof bit === 'string'"
              v-html="bit"
              :key="bit"
              style="text-align:left"
              class="grey--text text--darken-3"
            )
            ul(
              v-else-if="bit.constructor === Array"
              :key="String(bit)"
              style="text-align:left;line-height:1.8em"
              class="ml-3 grey--text text--darken-3"
            )
              //TODO add hash method for key
              li(
                v-for="piece in bit"
                :key="piece"
                v-html="piece"
                style="list-style-type:disc"
              )

      slot(v-else)

</template>

<script>
  import LenderListTile from '@/components/LenderListTile'
  import AppOutlinedButton from 'Components/AppOutlinedButton.vue'

  export default {
    name: 'lender-plan-expander',
    components: {
      LenderListTile,
      AppOutlinedButton
    },
    props: {
      lenderId: String,
      logoSvg: String,
      typeLabel: String,
      name: String,
      enrollmentLink: String,
      color: String,
      merchantId: String,
      status: String,
      description: Array,
      readMoreLink: String,
      active: {
        type: Boolean,
        default: null,
      },
    },
  }

</script>

<style scoped lang="scss">
  .slim-header >>> .expansion-panel__header{
    padding: 0;

    & .header__icon {
      margin-right: 10px;
    }
  }

  .header-btn-area {
    height: 100%;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
  }

</style>